import client from './client';

const Contragent = {
  getContragentInfo(anketId) {
    return client.get(`/ankets/${anketId}/contragent`);
  },
};

export default Contragent;
